import type { ListTileSpec } from "../ListTiles";
import type { ChartChip } from "../ChartChips";
import { pct, fmtCount } from "../listMath";

export interface BuyerStats {
  all: number; pe: number; strategic: number; indepSponsor: number; familyOffice: number; searchFund: number; other: number;
  engaged: number; unclassified: number; onTracker: number; withCriteria: number;
}

export function buyerTiles(s: BuyerStats): ListTileSpec[] {
  const classified = Math.max(0, s.all - s.unclassified);
  const cov = (covered: number, title: string) => ({ covered, total: s.all, title });
  return [
    { key: "total", label: "Total buyers", value: s.all,
      sub: s.all === 0 ? "no buyers match" : s.unclassified > 0 ? `${fmtCount(s.unclassified)} missing a firm type` : "every buyer has a firm type",
      coverage: cov(classified, `${fmtCount(classified)} have a firm type`) },
    { key: "engaged", label: "Spoken to", value: s.engaged, sub: `${pct(s.engaged, s.all)}% of the network`,
      coverage: cov(s.engaged, `${fmtCount(s.engaged)} spoken to`) },
    { key: "tracker", label: "On a buyer tracker", value: s.onTracker, sub: `${pct(s.onTracker, s.all)}% have been in a process`,
      coverage: cov(s.onTracker, `${fmtCount(s.onTracker)} on a tracker`) },
    { key: "criteria", label: "With deal criteria", value: s.withCriteria, sub: `${pct(s.withCriteria, s.all)}% · enrich to match buyers to deals`,
      coverage: cov(s.withCriteria, `${fmtCount(s.withCriteria)} with deal criteria`) },
  ];
}

export function buyerChips(s: BuyerStats): ChartChip[] {
  return [
    { key: "pe", label: "PE", count: s.pe },
    { key: "strategic", label: "Strategic", count: s.strategic },
    { key: "indepSponsor", label: "Indep. Sponsor", count: s.indepSponsor },
    { key: "familyOffice", label: "Family Office", count: s.familyOffice },
    { key: "searchFund", label: "Search Fund", count: s.searchFund },
    { key: "other", label: "Other", count: s.other },
    { key: "unclassified", label: "Unclassified", count: s.unclassified },
  ];
}
